<script>
import { mapState, mapActions } from 'vuex'
import AiAssistantWidget from '@/components/ai-assistant/AiAssistantWidget.vue'

export default {
  name: "app",
  components: {
    AiAssistantWidget
  },
  computed: {
    ...mapState({
      alert: state => state.alert,
      loggedIn: state => state.account.status.loggedIn
    })
  },
  methods: {
    ...mapActions({
      clearAlert: 'alert/clear'
    })
  },
  watch: {
    $route() {
      this.clearAlert();
    }
  }
};
</script>

<template>
  <div id="app">
    <RouterView />
    <AiAssistantWidget v-if="loggedIn" />
  </div>
</template>
